import(/* webpackMode: "eager", webpackExports: ["PublicGallery"] */ "/vercel/path0/src/app/[locale]/PublicGallery.tsx");
